import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Logo from '../../components/brand/Logo.jsx'
import Button from '../../components/ui/Button.jsx'
import Markdown from '../../components/ui/Markdown.jsx'
import LanguageSwitch from '../../components/ui/LanguageSwitch.jsx'
import api from '../../lib/api.js'

/*
 * Public legal document (/legal/:type) — GET /legal/:type → markdown content.
 * Footer/register slugs use `cgu` (terms) and `privacy`.
 */
export default function LegalPage() {
  const { type } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [content, setContent] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    setContent(null); setError(false)
    api.get(`/legal/${type}`).then(({ data }) => setContent(data?.content ?? '')).catch(() => setError(true))
  }, [type])

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg-page)' }}>
      <header style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 28px', borderBottom: '1px solid var(--color-border)', background: '#fff', position: 'sticky', top: 0, zIndex: 20 }}>
        <Logo size={25} onClick={() => navigate('/')} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <LanguageSwitch />
          <Button variant="secondary" onClick={() => navigate('/')}>{t('legal.back')}</Button>
        </div>
      </header>
      <div style={{ maxWidth: 820, margin: '0 auto', padding: '32px 24px 60px' }}>
        <div style={{ background: '#fff', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-card-lg)', boxShadow: 'var(--shadow-card)', padding: '36px 40px' }}>
          {error ? <div style={{ color: 'var(--color-text-muted)' }}>{t('legal.notFound')}</div>
            : content == null ? <div style={{ color: 'var(--color-text-muted)' }}>{t('common.loading')}</div>
            : <Markdown content={content} />}
        </div>
      </div>
    </div>
  )
}
